import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import Configurer from "../../components/Configurer";

import WidgetComponents from "../../components/widgets/WidgetComponents";
import { adminWidgets } from "../../variables/adminWidgets";
import { energyWidgets } from "../../variables/energyWidgets";
import { checkPermission, checkTranslation, getPermissionObject } from "../../utils/useful";
import { carbonWidgets } from "../../variables/carbonWidgets";
import { siteConfig } from "../../variables/config";


class AdminWidgetsPage extends React.Component {


    state = {
        // info: {
        modules: []
        // }
    }


    getModules = widget => {
        if (widget === 'energyPages') return Object.values(energyWidgets)
        if (widget === 'carbonPages') return Object.values(carbonWidgets)
        return Object.values(adminWidgets)
    }

    componentDidMount() {
        this.setState({ modules: this.getModules(this.props.widget) })
    }

    componentDidUpdate(prevProps) {
        if (this.props.widget !== prevProps.widget) {
            this.setState({ modules: this.getModules(this.props.widget) })
        }
    }




    render() {
        return (

            <Configurer
                settingsInfo={{ showFooter: true, showTabBar: true, showHeader: true, headerTitle: this.props.title, button: {} }}
                title={this.props.title}
                description={this.props.description}
                className=""

            >

                <div className={"row m-0"} >

                    <div className="col-12 pt-0 pb-4 ">

                        {/* <div className="px-0 mt-0 mb-4">
                            <p className="text-ultra-big " style={{ fontWeight: '500', color: '#222' }}>{checkTextTranslation(this.props.title)}</p>
                            <p className="text-small mt-2" style={{ color: '#456' }}>{checkTextTranslation(this.props.description)}</p>
                        </div> */}

                        <div className="row m-0">

                            {this.state.modules?.map((prop, index) => {
                                // Ensure a unique, stable key per widget instance
                                const widgetInstanceKey = prop._id || `${prop.key}_${index}`

                                let Component = WidgetComponents[prop.key]
                                // Check permission if permissionParent is defined
                                const hasPermission = prop.permissionParent 
                                    ? checkPermission(prop.permissionParent + '.view') 
                                    : true
                                
                                // Check if user has admin permissions
                                const hasAdminPermission = checkPermission('admin')
                                
                                // Check if user has "self" permission - if so, hide widgets in home (unless they have admin)
                                let hasSelfPermission = false
                                if (prop.permissionParent && this.props.user?.info) {
                                    const userPermissions = this.props.user.info.permissions || []
                                    for (let i = 0; i < userPermissions.length; i++) {
                                        const userPermission = userPermissions[i].permissions
                                        const permResult = getPermissionObject(userPermission, prop.permissionParent + '.self')
                                        if (permResult?.allowed) {
                                            hasSelfPermission = true
                                            break
                                        }
                                    }
                                }
                                
                                // Hide widgets in home if user has "self" permission but NOT admin permission
                                // (users with admin permissions should see widgets in home)
                                const isHome = !this.props.variables?.applet
                                if (isHome && hasSelfPermission && !hasAdminPermission) {
                                    return null
                                }
                                
                                if (Component && hasPermission) {
                                    const viewerUserType = this.props.user?.info?.userType || 'admin'
                                    let variables = {
                                        permissionRoot: prop.permissionParent,
                                        viewerUserType,
                                        ...(this.props.variables || {})
                                    }

                                    // Determine height based on widget type
                                    const isTableWidget = prop.key === 'TableWidget'
                                    const isContractsStatusWidget = prop.key === 'ContractsStatusWidget'
                                    const widgetHeight = isTableWidget ? '400px' : (isContractsStatusWidget ? 'auto' : '700px')

                                    return (
                                        <div className={"w-100 mb-1 p-1 col-12  col-md-" + (prop.col ?? "6")} key={widgetInstanceKey}>
                                            <div className="h-100 p-4 px-1 d-flex flex-column custom-scrollbar-widget" style={{ backgroundColor: '#fff', borderRadius: 10, boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px', maxHeight: widgetHeight === 'auto' ? undefined : widgetHeight, minHeight: widgetHeight === 'auto' ? undefined : widgetHeight, overflow: 'auto' }}>
                                                <p className="text-start text-bold mt-2 mb-3 text-normal">{checkTranslation(prop.title)}</p>
                                                <Component
                                                    widget={prop}
                                                    dashboard={this.state.info}
                                                    variables={variables}
                                                    user={this.props.user}
                                                    viewerUserType={viewerUserType}
                                                    useFakeData={siteConfig.testEnv}
                                                />
                                            </div>
                                        </div>
                                    )
                                }
                                return null
                            })}
                        </div>

                        {/* <DataGrid isLoading={this.state.isLoading} data={this.props.modules} component={AdminModule} col="col-12 col-sm-6 col-md-6 col-lg-3" settings={{route:this.props.route}} /> */}
                    </div>
                </div>
            </Configurer>
        )
    }


}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AdminWidgetsPage);
